"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PunchStatusModal = void 0;
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const Text_1 = require("@amzn/atoz-web/Text");
const View_1 = require("@amzn/atoz-web/View");
const Button_1 = require("@amzn/atoz-web/Button");
const Row_1 = require("@amzn/atoz-web/Row");
const Modal_1 = require("@amzn/atoz-web/Modal");
const Col_1 = require("@amzn/atoz-web/Col");
const Icons_1 = require("@amzn/atoz-web/Icons");
const Theme_1 = require("@amzn/atoz-web/Theme");
const usePunchStatusModal_1 = require("./hooks/usePunchStatusModal");
const PunchStatusModal = ({ status, reason, type, dateTime, initialDateTime, militaryTime = false, isCardLayout = false, closeModal }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { icon, titleKey, detailKey, detailOptionsLowerCase, timeString, dateString, initialTimeString, initialDateString, localedType } = (0, usePunchStatusModal_1.usePunchStatusModal)({
        dateTime,
        initialDateTime,
        militaryTime,
        status,
        reason,
        type,
        renderIconContainer,
        statusToUIKey,
        isCardLayout
    });
    const buttons = [
        react_1.default.createElement(CloseButton, { key: "PunchStatusModalCloseButton", variant: Button_1.ButtonVariant.Primary, onClick: closeModal, dataTestId: "punch-status-modal-close", "aria-label": t('time_and_attendance_PunchStatusModal_Close') }, t('time_and_attendance_PunchStatusModal_Close'))
    ];
    return !isCardLayout ? (react_1.default.createElement(Modal_1.ModalContent, { onCloseButtonClick: closeModal, dataTestId: "PunchStatusModal", titleText: "", buttons: buttons, closeButtonAltText: t('time_and_attendance_PunchStatusModal_Close') },
        react_1.default.createElement(Col_1.Col, { alignItems: "center", margin: { bottom: 'S300', top: 'S600' } },
            icon,
            react_1.default.createElement(Text_1.H1, { fontSize: "T400", fontWeight: 500, color: "neutral100" }, t(titleKey)),
            react_1.default.createElement(Text_1.Text, { color: "neutral80", fontSize: "T200" }, t(detailKey, {
                type: detailOptionsLowerCase
                    ? localedType.toLocaleLowerCase()
                    : localedType
            }))),
        react_1.default.createElement(Text_1.H2, { fontSize: "T400", fontWeight: 500, color: "neutral100" }, localedType),
        react_1.default.createElement(Text_1.Text, { color: "neutral80", fontSize: "T200" }, `${timeString} | ${dateString}`),
        initialTimeString && initialDateString && (react_1.default.createElement(Text_1.Text, { color: "neutral80", fontSize: "T200" },
            react_1.default.createElement("em", null,
                t('time_and_attendance_StatusOverview_Note_InitialPunch'),
                ":",
                ' ',
                initialTimeString,
                " | ",
                initialDateString))))) : (react_1.default.createElement(View_1.View, { dataTestId: "PunchStatusCard" },
        react_1.default.createElement(Row_1.Row, { alignItems: "center" },
            icon,
            react_1.default.createElement(Text_1.H1, { fontSize: "T400", fontWeight: 500, color: "neutral100" }, t(titleKey))),
        react_1.default.createElement(Text_1.Text, { color: "neutral80", fontSize: "T200", margin: { bottom: 'S300' } }, t(detailKey, {
            type: detailOptionsLowerCase
                ? localedType.toLocaleLowerCase()
                : localedType
        })),
        react_1.default.createElement(Text_1.H2, { fontSize: "T200", color: "neutral100" }, localedType),
        react_1.default.createElement(Text_1.Text, { color: "neutral80", fontSize: "T200" }, `${timeString} | ${dateString}`),
        initialTimeString && initialDateString && (react_1.default.createElement(Text_1.Text, { color: "neutral80", fontSize: "T200" },
            react_1.default.createElement("em", null,
                t('time_and_attendance_StatusOverview_Note_InitialPunch'),
                ":",
                ' ',
                initialTimeString,
                " | ",
                initialDateString)))));
};
exports.PunchStatusModal = PunchStatusModal;
const CloseButton = (0, Theme_1.styledWithTheme)(Button_1.Button)(`
    width: 100%;
  `);
const iconProps = {
    size: 20,
    dataTestId: 'StatusIcon'
};
const statusToUIKey = {
    success: Object.assign(Object.assign({}, usePunchStatusModal_1.statusToUIKeyBase.success), { iconComp: react_1.default.createElement(Icons_1.IconCheckCircleFill, Object.assign({}, iconProps, { color: "green60" })) }),
    further_review: Object.assign(Object.assign({}, usePunchStatusModal_1.statusToUIKeyBase.further_review), { iconComp: react_1.default.createElement(Icons_1.IconRefresh, Object.assign({}, iconProps, { color: "neutral70" })) }),
    under_review: Object.assign(Object.assign({}, usePunchStatusModal_1.statusToUIKeyBase.under_review), { iconComp: react_1.default.createElement(Icons_1.IconRefresh, Object.assign({}, iconProps, { color: "neutral70" })) }),
    processing: Object.assign(Object.assign({}, usePunchStatusModal_1.statusToUIKeyBase.processing), { iconComp: react_1.default.createElement(Icons_1.IconRefresh, Object.assign({}, iconProps, { color: "neutral70" })) }),
    system_error: Object.assign(Object.assign({}, usePunchStatusModal_1.statusToUIKeyBase.system_error), { iconComp: react_1.default.createElement(Icons_1.IconAlertCircleFill, Object.assign({}, iconProps, { color: "red70" })) }),
    not_accepted: Object.assign(Object.assign({}, usePunchStatusModal_1.statusToUIKeyBase.not_accepted), { iconComp: react_1.default.createElement(Icons_1.IconAlertCircleFill, Object.assign({}, iconProps, { color: "red70" })) })
};
const IconContainer = (0, Theme_1.styledWithTheme)('div')(({ theme, isCardLayout }) => {
    if (isCardLayout) {
        return `
        margin-right: ${theme.selectors.space('S200')}px;
      `;
    }
    return `
      transform: scale(3.2);
      margin-bottom: ${theme.selectors.space('S400')}px;
    `;
});
const renderIconContainer = (iconComp, isCardLayout) => {
    return react_1.default.createElement(IconContainer, { isCardLayout: isCardLayout }, iconComp);
};
